module.exports = __webpack_public_path__ + "img/team-members-icon.2d1463a3.svg";